"use strict";

window.modalHotelData = null;

//init hotel stars
$(".getRating").giveScore({
  TotalNum: 5,
  getScore: false,
  setScore: true,
  fontIcon: true,
  htmlelement: false,
  writeScore: false,
  getAndSet: false,
  iclasses: {
    unselect: "icon-star",
    select: "icon-star-yellow",
    halfIcon: "icon-star-half",
  },
});

//init four-columns slider
$(".js-four-columns").owlCarousel({
  loop: false,
  margin: 8,
  rtl: true,
  responsiveClass: true,
  autoWidth: false,
  dots: false,
  nav: true,
  responsive: {
    0: {
      items: 1.5,
      nav: false,
      autoWidth: true,
      margin: 8,
    },
    768: {
      items: 3,
      autoWidth: false,
    },
    1180: {
      items: 4.5,
      autoWidth: true,
      margin: 24,
    },
  },
});

function setFilterValue({ value, prevValue = null, checked }) {
  let newValue = null;

  if (checked) {
    newValue = prevValue ? `${prevValue},${value}` : value;
  } else {
    let format = prevValue.indexOf(value) === 0 ? `${value},` : `,${value}`;
    if (prevValue.length === 1) format = `${value}`;

    newValue = prevValue.replace(format, "");
  }

  return newValue;
}

// async function checkBoxFilter() {
//   let dataType = $(this).attr("data-type");
//   let prevValue = null;

//   if (window.hotelDataModel?.filter) {
//     prevValue = window.hotelDataModel.filter[dataType];
//   }

//   let newValue = await setFilterValue({
//     value: $(this).attr("value"),
//     prevValue,
//     checked: this.checked,
//   });

//   if (newValue === "") {
//     delete window.hotelDataModel.filter[dataType];
//   } else {
//     window.hotelDataModel.filter = { ...{ [dataType]: newValue } };
//   }

//   openPopModal();
// }

function tabActivation(selectedItem, activeClassName) {
  $(`.${activeClassName}`).removeClass(activeClassName);
  $(selectedItem).addClass(activeClassName);
}

const setSortValue = (value) => {
  window.hotelDataModel.sort = value;
};

function sort() {
  tabActivation(this, "is-active");
  setSortValue($(this).attr("sort-value"));
  openPopModal();
}

async function saveOldSearchBoxData(selectedItem = null) {
  window.mainHotelData = $.extend(true, {}, window.hotelDataModel);

  window.hotelDataModel = window.modalHotelData
    ? $.extend(true, {}, window.modalHotelData)
    : $.extend(true, {}, window.hotelDataModel);

  window.hotelDataModel.id = $(selectedItem).attr("data-id")
    ? $(selectedItem).attr("data-id")
    : window.mainHotelData.id;
  window.hotelDataModel.slug = $(selectedItem).attr("data-slug")
    ? $(selectedItem).attr("data-slug")
    : window.mainHotelData.slug;
  window.hotelDataModel.sort = $(selectedItem).attr("sort-value")
    ? $(selectedItem).attr("sort-value")
    : window.mainHotelData.sort;
  window.hotelDataModel.filter = window.mainHotelData.filter;
}

function restoreOldSearchBoxData() {
  window.modalHotelData = $.extend(true, {}, window.hotelDataModel);
  window.hotelDataModel = $.extend(true, {}, window.mainHotelData);
}

function setDestinationTitle(selectedItem = null) {
  const modalDestinationTitle = $(selectedItem).attr("data-title")
    ? $(selectedItem).attr("data-title")
    : window.mainHotelData.hotelTitle;

  $(".js-hotel-destinations-popup")
    .find("#js-hotel-city")
    .val(modalDestinationTitle);
}

function openPopModal() {
  $("body").toggleClass("no-scroll");

  saveOldSearchBoxData(this).then(setDestinationTitle(this));

  $(".js-hotel-destinations-popup").addClass("is-open");
}

function closePopupModal(e) {
  if (
    $(e.target).hasClass("js-close-popup-modal") ||
    $(e.target).hasClass("js-hotel-destinations-popup")
  ) {
    $("body").toggleClass("no-scroll");

    restoreOldSearchBoxData();

    $(this).find(".error-message").remove();

    $(".js-hotel-destinations-popup").removeClass("is-open");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  //init popup title
  $(".js-hotel-destinations-popup-title").text(
    window.searchInitialize.search.destinations.title
  );

  // $(".checkmark").each(function () {
  //   $(this).on("change", checkBoxFilter);
  // });

  $(".js-hotel-destinations-sort-item").click(sort);

  // TODO: after implementing the app part for hotels destination this part should be implemented
  // $(".js-hotel-destinations-no-link").click(openPopModal);

  $(".js-hotel-destinations-popup").click(closePopupModal);

  $(".js-table-content-link").click(function () {
    $(".js-table-content-link").removeClass("active");

    $(this).addClass("active");
  });
});

$(window).scroll(function () {
  // while scroll change active btn
  let links = $(".js-table-content-link");
  let items = Array.from(document.querySelectorAll(".js-table-content-item"));

  items.forEach(function (item) {
    let itemOffsetTop = item.getBoundingClientRect().top + window.scrollY;
    let itemHeight = item.offsetHeight;
    let itemId = item.querySelector(".js-table-content-item-title")
      ? item.querySelector(".js-table-content-item-title").id
      : null;

    if (
      itemId &&
      window.scrollY > itemOffsetTop - 62 &&
      window.scrollY < itemHeight + itemOffsetTop
    ) {
      links.removeClass("active");

      document
        .querySelector(".js-table-content-link[href='#" + itemId + "']")
        .classList.add("active");
    }
  });
});
